import FullScreenVideo from './FullScreenVideo';

export default FullScreenVideo;
